module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/pt-br-card-drag.02d828a6f93778622e85.gif";